import React, { useEffect, useState } from 'react';
import SupervisorGroupSearchModal from './SupervisorGroupSearchModal';
import { resolveSupervisorGroupById } from '../utils/supervisorLookup';

/**
 * Champ "id groupe" reutilisable cote superviseur — meme comportement que
 * SupervisorBankCodeField.jsx/LotteryCodeField.jsx (resolution au blur, pas
 * seulement via le modal 🔍). Voir SupervisorBankCodeField pour le detail du
 * contrat de props.
 */
export default function SupervisorGroupCodeField({
  value,
  name = '',
  onChange,
  onResolve,
  inputClass = '',
  iconClass = '',
  nameClass = '',
  errClass = '',
  placeholder,
}) {
  const [err, setErr] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  // Texte AFFICHE (le numero seq tape/choisi) distinct de `value` (l'id interne
  // renvoye a la page via onResolve) — avant, la case affichait `value`, donc
  // l'id interne apres resolution, et un 2e blur relisait cet id comme un seq
  // (-> "introuvable" ou, pire, un AUTRE element). Corrige 2026-09-24.
  const [text, setText] = useState('');

  // La page a vide la valeur (changement de filtre...) -> vide aussi la case.
  useEffect(() => { if (!value) setText(''); }, [value]);

  const resolve = async () => {
    const c = String(text ?? '').trim();
    if (c === '') { setErr(''); return; }
    const r = await resolveSupervisorGroupById(c);
    if (r) { onResolve(r.id, r.name); setErr(''); } else { setErr('Groupe introuvable'); }
  };

  return (
    <>
      <input
        className={inputClass}
        type="text"
        inputMode="numeric"
        value={text}
        placeholder={placeholder}
        onChange={(e) => { setText(e.target.value); onChange(e.target.value); setErr(''); }}
        onFocus={(e) => e.target.select()}
        onBlur={resolve}
      />
      <span className={iconClass} onClick={() => setModalOpen(true)}>🔍</span>
      {err
        ? <span className={errClass || nameClass} style={{ color: '#c0392b' }}>{err}</span>
        : (name ? <span className={nameClass}>{name}</span> : null)}
      {modalOpen && (
        <SupervisorGroupSearchModal
          onSelect={(id, nm, seq) => { setText(seq != null ? String(seq) : ''); onResolve(String(id), nm); setErr(''); }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
